import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminPageShell, { AdminSurface } from '../../../components/Admin/AdminPageShell';
import { getApiUrl } from '../../../utils/site';

const AddDesign = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [status, setStatus] = useState('approved');
  const [isPublic, setIsPublic] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('status', status);
      formData.append('is_public', isPublic ? 1 : 0);
      if (image) formData.append('image', image);
      const token = localStorage.getItem('token');
      await axios.post(getApiUrl('/api/designs'), formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setSuccess('Design added successfully!');
      setTimeout(() => navigate('/admin/design'), 1200);
    } catch (err) {
      setError('Failed to add design');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminPageShell
      eyebrow="Creative library"
      title="Add Design"
      description="Create a new design record, upload imagery, and control whether it appears in the public gallery."
    >
      <AdminSurface title="Design composer" subtitle="Add a gallery-ready design asset">
      <form className="roha-admin-form-grid" onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="roha-admin-field">
          <label>Title</label>
          <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} required />
        </div>
        <div className="roha-admin-field">
          <label>Description</label>
          <textarea className="form-control" value={description} onChange={e => setDescription(e.target.value)} required />
        </div>
        <div className="roha-admin-field">
          <label>Image</label>
          <input type="file" className="form-control" accept="image/*" onChange={e => setImage(e.target.files[0])} />
        </div>
        <div className="roha-admin-form-grid roha-admin-form-grid--two">
        <div className="roha-admin-field">
          <label>Status</label>
          <select className="form-select" value={status} onChange={e => setStatus(e.target.value)}>
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div className="roha-admin-field">
          <label>Show in Gallery</label>
          <label className="roha-admin-toggle">
            <input type="checkbox" checked={isPublic} onChange={e => setIsPublic(e.target.checked)} />
            <span />
          </label>
        </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <div className="roha-admin-toolbar">
          <button type="submit" className="roha-admin-navbar__chip roha-admin-navbar__chip--primary" disabled={loading}>
            {loading ? 'Saving...' : 'Add design'}
          </button>
          <button type="button" className="roha-admin-navbar__chip" onClick={() => navigate('/admin/design')}>
            Cancel
          </button>
        </div>
      </form>
      </AdminSurface>
    </AdminPageShell>
  );
};

export default AddDesign;
